import React from 'react';
import PropTypes from 'prop-types';

import styles from './Breadcrumbs.m.sass';

import {Link} from 'react-router';

export default function Breadcrumbs({links = []}) {
  return (
    <div className={styles.breadcrumbs}>
      {links.map(({name, slug}, idx) => (
        <span
          key={idx} className={styles.breadcrumbs_item}
        >
          {slug ? (
            <Link to={slug} className={styles.breadcrumbs_link}>{name}</Link>
          ) : (
            name
          )}
        </span>
      ))}
    </div>
  );
}

Breadcrumbs.propTypes = {
  links: PropTypes.array
};



// WEBPACK FOOTER //
// ./components/breadcrumbs/Breadcrumbs.js